/**
 * Checks to see if the serviceType is dinein inside the `query` object.
 * If it is, we want to disable the user from navigating via the site header
 *
 * @param route
 * @param store
 */
const dinein = ({ route, store }) => {
    if (route?.query.serviceType === 'dinein') {
        store.dispatch('header/setHeaderNavigationDisabled', true);
    }
};

export default dinein;
